import { render, staticRenderFns } from "./ConexionDispositivo.vue?vue&type=template&id=2964f98a&scoped=true"
import script from "./ConexionDispositivo.vue?vue&type=script&lang=js"
export * from "./ConexionDispositivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2964f98a",
  null
  
)

export default component.exports